import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PublicWebsite from "./PublicWebsite";
import { AdminAuthProvider } from "./admin/context/AdminAuthContext";
import ProtectedRoute from "./admin/components/ProtectedRoute";
import AdminLayout from "./admin/components/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import AdminDashboard from "./admin/pages/AdminDashboard";
import AdminProjects from "./admin/pages/AdminProjects";
import AdminServices from "./admin/pages/AdminServices";
import AdminPackages from "./admin/pages/AdminPackages";
import AdminGallery from "./admin/pages/AdminGallery";
import AdminTestimonials from "./admin/pages/AdminTestimonials";
import AdminEnquiries from "./admin/pages/AdminEnquiries";
import AdminSettings from "./admin/pages/AdminSettings";
import AdminMediaLibrary from "./admin/pages/AdminMediaLibrary";

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <Routes>
          {/* Public Website Route */}
          <Route path="/" element={<PublicWebsite />} />

          {/* Admin Authentication Route */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin CMS Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="packages" element={<AdminPackages />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="media" element={<AdminMediaLibrary />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Route>

          {/* Catch-all fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;